import { Tab } from '@/components/Sidebar/config'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import queryClient from '../queryClient'

const PAGE_NEED_REFRESH_FLAGS_QUERY_KEY = ['PAGE_NEED_REFRESH_FLAGS']

const DEFAULT_PAGE_NEED_REFRESH_FLAGS = {
	[Tab.FOLLOWING_POST]: false,
	[Tab.EXPLORE_POST]: false,
	[Tab.NOTIFICATION]: false,
	[Tab.USER_PROFILE]: false,
	[Tab.MORE]: false,
}
export function resetPageNeedRefreshFlags() {
	queryClient.setQueryData(PAGE_NEED_REFRESH_FLAGS_QUERY_KEY, DEFAULT_PAGE_NEED_REFRESH_FLAGS)
}
export function markTabNeedRefresh(tab: Tab) {
	queryClient.setQueryData(PAGE_NEED_REFRESH_FLAGS_QUERY_KEY, (prev: Record<Tab, boolean>) => {
		return {
			...prev,
			[tab]: true,
		}
	})
}

export default function usePageNeedRefreshSubscriber(tab: Tab, action: () => void) {
	const { data: needRefresh } = useSuspenseQuery({
		queryKey: PAGE_NEED_REFRESH_FLAGS_QUERY_KEY,
		queryFn: () => DEFAULT_PAGE_NEED_REFRESH_FLAGS,
		select: (data) => data[tab] ?? false,
	})

	useEffect(() => {
		if (needRefresh) {
			action()
			resetPageNeedRefreshFlags()
		}
	}, [needRefresh])
}
